export default __webpack_public_path__ + "static/media/zjazd.5fd7c222.png";